import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import apiAxios from 'helpers/apiAxios';

export const fetchCalendar = createAsyncThunk(
  'bookingCalendar/fetch',
  async (params, { rejectWithValue }) => {
    try {
      const { data } = await apiAxios.get('/booking/calendar', { params });
      return data;
    } catch (err) {
      return rejectWithValue(err.response?.data);
    }
  }
);

const calendarSlice = createSlice({
  name: 'booking_calendar',
  initialState: { events: [], loading: false },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCalendar.pending,   (state) => { state.loading = true; })
      .addCase(fetchCalendar.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.events  = payload || [];
      })
      .addCase(fetchCalendar.rejected,  (state) => { state.loading = false; });
  },
});

export default calendarSlice.reducer;
